import { handleServiceError } from '../helpers/app';
import { ResponseObject } from '../interfaces/App';
import { ChatAgentFormData } from '../interfaces/ChatAgent';
import apiRequest from './apiService';

const getChatAgent = async (id: string) => {
  try {
    const result = await apiRequest(
      'chat_agent',
      'GET',
      `/get_chat_agent/${id}`
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'chat_agent');
  }
};

const getChatAgents = async (
  agentIds: string[] = []
): Promise<ResponseObject> => {
  try {
    const result: ResponseObject = await apiRequest(
      'chat_agent',
      'GET',
      `/get_chat_agents/${agentIds.join(',')}`
    );
    return result;
  } catch (err: unknown) {
    return handleServiceError(err, 'chat_agent');
  }
};

const createChatAgent = async (formData: ChatAgentFormData) => {
  try {
    const response = await apiRequest(
      'chat_agent',
      'POST',
      '/create_chat_agent',
      formData,
      null,
      undefined
    );
    return response;
  } catch (error: unknown) {
    handleServiceError(error, 'chat_agent');
  }
};

const updateChatAgent = async (id: string, data: any = {}) => {
  try {
    const result = await apiRequest(
      'chat_agent',
      'PUT',
      `/update_chat_agent/${id}`,
      data
    );
    return result;
  } catch (error: unknown) {
    handleServiceError(error, 'chat_agent');
  }
};

const uploadAvatar = async (
  fileName: string,
  fileContent: string,
  userId: string,
  agentId: string
) => {
  try {
    const response: ResponseObject = await apiRequest(
      'storage',
      'POST',
      '/upload_file',
      {
        user_id: userId,
        agent_id: agentId,
        file_type: 'image',
        file_name: fileName,
        file_content: fileContent,
      }
    );
    return response;
  } catch (error: unknown) {
    handleServiceError(error, 'chat_agent');
  }
};

const getCompanyChatAgents = async (): Promise<ResponseObject> => {
  try {
    const result: ResponseObject = await apiRequest(
      'chat_agent',
      'GET',
      '/get_company_chat_agents'
    );
    return result;
  } catch (err: unknown) {
    return handleServiceError(err, 'chat_agent');
  }
};

const deleteChatAgent = async (id: string) => {
  try {
    const result = await apiRequest(
      'chat_agent',
      'DELETE',
      `/chat_agent/delete_object/${id}`
    );
    return result;
  } catch (error: unknown) {
    return handleServiceError(error, 'chat_agent');
  }
};

export {
  createChatAgent,
  deleteChatAgent,
  getChatAgent,
  getChatAgents,
  getCompanyChatAgents,
  updateChatAgent,
  uploadAvatar,
};
